import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e31e695"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex h-full flex-grow flex-col xl:flex-row" }
const _hoisted_2 = { class: "navigation-sm" }

import { ComputedRef, Ref, computed, ref } from 'vue';
import { Router, useRouter } from 'vue-router';
import { UseSwipeReturn, useSwipe } from '@vueuse/core';
import { useLocationStore } from '@/stores/location';
import AppIcon from '@/components/Base/AppIcon.vue';
import AppMarketplaceProvider from '@/components/Base/AppMarketplaceProvider.vue';
import AppMarketplaceView from '@/components/Base/AppMarketplaceView.vue';
import AppMaintenance from '@/components/Base/AppStatus/AppMaintenance.vue';
import AppOffline from '@/components/Base/AppStatus/AppOffline.vue';
import CategorySidemenu from '@/components/CategorySidemenu/CategorySidemenu.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultLayout',
  setup(__props) {

const locationStore = useLocationStore();
const router: Router = useRouter();

const view: Ref<HTMLElement | null> = ref(null);
const navigationOnCanvas: Ref<boolean> = ref(false);

const swipe: UseSwipeReturn = useSwipe(view, {
  onSwipe(): void {
    if (swipe.lengthX.value < -100) {
      showNavigation();
    } else if (swipe.lengthX.value > 100) {
      hideNavigation();
    }
  },
});

const showNavigation = (): void => {
  navigationOnCanvas.value = true;
};

const hideNavigation = (): void => {
  navigationOnCanvas.value = false;
};

const categorySidemenuNavigate = (): void => {
  hideNavigation();
};

const maintenance: ComputedRef<boolean> = computed((): boolean => {
  return locationStore.maintenance;
});

const offline: ComputedRef<boolean> = computed((): boolean => {
  return locationStore.offline;
});

router.afterEach((): void => {
  locationStore.maintenance = false;
  locationStore.offline = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppMarketplaceView, {
    ref_key: "view",
    ref: view
  }, {
    default: _withCtx(() => [
      _createVNode(AppMarketplaceProvider, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("button", {
                class: "h-full",
                onClick: showNavigation
              }, [
                _createVNode(AppIcon, {
                  src: "/assets/images/icon.png",
                  class: "h-full"
                })
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass({
            backdrop: true,
            'pointer-events-none bg-dark-100 bg-opacity-0': !navigationOnCanvas.value,
            'bg-dark-100 bg-opacity-70': navigationOnCanvas.value,
          }),
              onClick: hideNavigation
            }, null, 2),
            _createElementVNode("nav", {
              class: _normalizeClass({
            navigation: true,
            '-translate-x-full': !navigationOnCanvas.value,
            'translate-x-0': navigationOnCanvas.value,
          })
            }, [
              _createVNode(CategorySidemenu, { onNavigate: categorySidemenuNavigate })
            ], 2),
            (_openBlock(), _createElementBlock("main", {
              key: _unref(locationStore).reload,
              class: "h-full w-full overflow-y-hidden bg-dark-100 xl:w-3/4"
            }, [
              (_unref(maintenance))
                ? (_openBlock(), _createBlock(AppMaintenance, { key: 0 }))
                : (_unref(offline))
                  ? (_openBlock(), _createBlock(AppOffline, { key: 1 }))
                  : _renderSlot(_ctx.$slots, "default", { key: 2 })
            ]))
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 512))
}
}

})